import { DefaultService } from '@/services/DefaultService';

export default class AgroFenologiaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(filtro, column, order, page = 0, limit = 20, ...params) {
      return this._http.post(encodeURI(`${this._env}/agro/fenologia.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), filtro, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
      });
    }

    save(obj) {
      return this._http.post(`${this._env}/agro/fenologia`, obj, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw err;
      });
    }

    findByUuid(uuid) {
      return this._http.get(`${this._env}/agro/fenologia/uuid/${uuid}.json`, this._headers).then(res => {
        return res.body;
      }, err => {
        this.verifyError(err);
        throw new Error('Problems while jobs are loading');
      });
    }
}